module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/paige-richmond-c5439211274b519b49eb60e5b03a03e7.jpg";